import { render, staticRenderFns } from "./beacons.vue?vue&type=template&id=c2eea17e&"
import script from "./beacons.vue?vue&type=script&lang=js&"
export * from "./beacons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports